// VNEC v9 — pages/prepaid.js
// V9 schema: prepaid_allocation = (chi_phi_id, thang 'YYYY-MM', gia_tri_pb)
// Mỗi CP phân bổ nhiều dòng (mỗi tháng 1 row). Aggregate client-side.
import { supabase } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';

export async function renderPrepaid() {
  window.__pageInit = load;
  return `
    <div class="page">
      <div class="page-header">
        <h1>CP Chờ Phân Bổ (Prepaid)</h1>
        <a href="#" class="btn btn-ghost btn-sm" id="pp-refresh">⟳</a>
      </div>
      <div class="card" id="summary"></div>
      <div class="card">
        <div class="table-wrap">
          <table class="table" id="pp-table">
            <thead><tr>
              <th>Tên CP</th><th>Loại CP</th>
              <th class="num">Tổng TT (gốc)</th>
              <th class="num">Tổng tháng PB</th>
              <th class="num">Đã phân bổ</th>
              <th class="num">Còn lại</th>
              <th class="num">Tháng đã chạy</th>
              <th>Tháng gần nhất</th>
            </tr></thead>
            <tbody><tr><td colspan="8" class="muted center">Đang tải...</td></tr></tbody>
          </table>
        </div>
      </div>
    </div>`;
}

async function load() {
  const tbody = document.querySelector('#pp-table tbody');
  const summary = document.getElementById('summary');
  document.getElementById('pp-refresh').addEventListener('click', (e) => { e.preventDefault(); load(); });

  // 1) Query all prepaid CP (phan_loai='Prepaid', approved)
  const { data: cpList, error: cpErr } = await supabase.from('chi_phi')
    .select('id, ten_cp, loai_cp, tong_tt, ghi_chu, so_thang_pb')
    .eq('phan_loai', 'Prepaid').eq('trang_thai', 'approved').is('deleted_at', null)
    .order('ngay_ct', { ascending: false }).limit(500);
  if (cpErr) { tbody.innerHTML = `<tr><td colspan="8">Lỗi: ${cpErr.message}</td></tr>`; return; }

  // 2) Query all allocations in one go
  const cpIds = (cpList || []).map(r => r.id);
  let allocByCp = {};
  if (cpIds.length) {
    const { data: allocs } = await supabase.from('prepaid_allocation')
      .select('chi_phi_id, thang, gia_tri_pb').in('chi_phi_id', cpIds);
    (allocs || []).forEach(a => {
      if (!allocByCp[a.chi_phi_id]) allocByCp[a.chi_phi_id] = { sum: 0, count: 0, last: '' };
      const g = allocByCp[a.chi_phi_id];
      g.sum += Number(a.gia_tri_pb || 0);
      g.count += 1;
      if (a.thang > g.last) g.last = a.thang;
    });
  }

  // 3) Aggregate rows
  const rows = (cpList || []).map(cp => {
    const g = allocByCp[cp.id] || { sum: 0, count: 0, last: '' };
    const goc = Number(cp.tong_tt || 0);
    const daPB = g.sum;
    const conLai = Math.max(0, goc - daPB);
    return { ...cp, daPB, conLai, thangCount: g.count, lastThang: g.last };
  });

  const tongGoc = rows.reduce((s, r) => s + Number(r.tong_tt || 0), 0);
  const tongDaPB = rows.reduce((s, r) => s + r.daPB, 0);
  const tongConLai = rows.reduce((s, r) => s + r.conLai, 0);
  summary.innerHTML = `
    <div class="kpi-grid">
      <div class="kpi-card"><div class="kpi-label">Tổng giá trị gốc</div><div class="kpi-value">${formatVND(tongGoc)} đ</div></div>
      <div class="kpi-card"><div class="kpi-label">Đã phân bổ</div><div class="kpi-value">${formatVND(tongDaPB)} đ</div></div>
      <div class="kpi-card warning"><div class="kpi-label">Còn lại (Gold)</div><div class="kpi-value">${formatVND(tongConLai)} đ</div></div>
      <div class="kpi-card"><div class="kpi-label">Số CP Prepaid</div><div class="kpi-value">${rows.length}</div></div>
    </div>`;

  if (!rows.length) { tbody.innerHTML = '<tr><td colspan="8" class="muted center">Chưa có chi phí Prepaid đã duyệt.</td></tr>'; return; }
  tbody.innerHTML = rows.map(r => {
    // Lấy số tháng PB: ưu tiên cột so_thang_pb, fallback parse ghi_chu, cuối cùng 12
    let totalMonths = r.so_thang_pb;
    if (!totalMonths) {
      const m = (r.ghi_chu || '').match(/(\d+)\s*th[aá]ng/i);
      totalMonths = m ? parseInt(m[1], 10) : 12;
    }
    const isManual = !!r.so_thang_pb;
    return `
    <tr>
      <td class="small"><strong>${r.ten_cp || '—'}</strong></td>
      <td class="small">${r.loai_cp || ''}</td>
      <td class="num">${formatVND(r.tong_tt)}</td>
      <td class="num bold" style="color:${isManual ? '#085041' : '#888780'}" title="${isManual ? 'Nhập thủ công' : 'Tự suy ra (mặc định)'}">${totalMonths} ${isManual ? '' : '*'}</td>
      <td class="num">${formatVND(r.daPB)}</td>
      <td class="num bold">${formatVND(r.conLai)}</td>
      <td class="num">${r.thangCount}/${totalMonths}</td>
      <td class="small muted">${r.lastThang || '—'}</td>
    </tr>`;
  }).join('');
  // Footnote
  if (rows.some(r => !r.so_thang_pb)) {
    tbody.insertAdjacentHTML('beforeend',
      '<tr><td colspan="8" class="small muted" style="padding-top:8px"><em>* CP chưa có số tháng phân bổ thủ công — đang dùng mặc định 12 tháng. Admin có thể cập nhật trong form.</em></td></tr>');
  }
}
